/**
 * Normalized backend origin for API calls (always ends with `/`).
 * Matches Vite dev server (8080) vs API (e.g. 3002) so Google OAuth hits the real backend.
 */
export function getPublicApiBaseUrl(): string {
  const raw = import.meta.env.VITE_PUBLIC_BASE_URL;
  if (raw == null || String(raw).trim() === "") {
    return "http://localhost:3002/";
  }
  const trimmed = String(raw).trim().replace(/\/+$/, "");
  return trimmed ? `${trimmed}/` : "http://localhost:3002/";
}
